// Try to avoid using the global scope, but if you have to use it, put variables/functions here.

import {useEpsonStore, useUnchangingStore, useUserStore, useCounterStore} from "@/console-new/stores";
import API from "@/shared/helpers/API.js";
import {isAndroid, isNative} from "@/shared/helpers/webapp.js";
import {Epson} from "@/console-new/helpers/epson";
import {useSunmiStore} from "@/console-sun/stores";
import {useNotificationStore} from "@/shared/stores";
import {registerCashmaticCallbacks} from "@/shared/helpers/cashmaticCallbacks";

window.relativeBase = "../";

// this function has the purpose of handling the payment intent triggered from other native apps
window.handlePaymentIntentFromExternal = function (amount, details) {
	if (isAndroid()) {
		// Validate amount is a positive number
		const numAmount = Number(amount);
		if (!Number.isFinite(numAmount) || numAmount <= 0) {
			console.error('Invalid payment amount:', amount);
			return;
		}
		// Sanitize details string
		const sanitizedDetails = details ? String(details).trim() : '';
		useCounterStore().externalPaymentIntentData = {amount: numAmount, details: sanitizedDetails};
	}
}

window.fiscalReceiptResult = function (orderIds, result, rawRequest = null, rawResponse = null) {
	orderIds = JSON.parse(orderIds);

	Epson.printDone();
	let epsonStore = useEpsonStore();
	if(result) {
		if(TEST) {
			console.log("FISCAL RECEIPT SUCCESS " + rawResponse);
		}

		const parser = new DOMParser();
		const xmlDoc = parser.parseFromString(rawResponse, "text/xml");

		const fiscalReceiptNumber = xmlDoc.querySelector("fiscalReceiptNumber");
		const fiscalReceiptDate = xmlDoc.querySelector("fiscalReceiptDate");
		const fiscalReceiptAmount = xmlDoc.querySelector("fiscalReceiptAmount");
		const zRepNumber = xmlDoc.querySelector("zRepNumber");

		let receiptData = null;
		if(fiscalReceiptNumber && zRepNumber && fiscalReceiptDate && fiscalReceiptAmount) {
			function parseDate(dateString) {
				const [day, month, year] = dateString.split('/');
				let date = new Date(year, month - 1, day);
				return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
			}

			receiptData = {
				receiptNumber: fiscalReceiptNumber.textContent,
				zrep: zRepNumber.textContent,
				date: parseDate(fiscalReceiptDate.textContent),
				total: Math.round(Number(fiscalReceiptAmount.textContent.replace(",", "."))*100),
			}
		}

		epsonStore.fiscalReceiptSuccess(orderIds, receiptData ? JSON.stringify(receiptData) : null);

		if(rawRequest && !rawRequest.includes("<printRecItem")) {
			epsonStore.logError(rawRequest, rawResponse, "999", null, null);
		}
	} else {
		if(rawResponse) {
			let code = null;
			let lastCommand = null;
			let printerStatus = null;

			const parser = new DOMParser();
			const xmlDoc = parser.parseFromString(rawResponse, "text/xml");
			const responseElements = xmlDoc.getElementsByTagName("response");
			if(responseElements.length > 0) {
				const statusCode = responseElements[0].getAttribute("status");
				if(statusCode) {
					code = statusCode;
				}

				const lastCommandElement = xmlDoc.getElementsByTagName("lastCommand")[0];
				if(lastCommandElement) {
					lastCommand = lastCommandElement.textContent;
				}
				const printerStatusElement = xmlDoc.getElementsByTagName("printerStatus")[0];
				if(printerStatusElement) {
					printerStatus = printerStatusElement.textContent;
				}
			}

			if(TEST) {
				console.log("ERROR RESPONSE:", code, lastCommand, printerStatus);
			}

			epsonStore.logError(rawRequest, rawResponse, code, lastCommand, printerStatus);

			epsonStore.fiscalPrinterFailed = ""+code;

		} else {
			epsonStore.fiscalPrinterFailed = true;
		}
	}

}

/**
 * this function is used by the native app so you won't find any reference to it in the code
 * it gets triggered by the native app via the getNative() function in webapp.js
 * in this specific case to find usage of this function search for getNative().updateDevice();
 *
 * To have a deeper understanding of how this works check the source code the native app, for example the DeviceFunctions.kt
 */
window.updateBusinessDevice = function(deviceId, token, soundIndex) {
	let userStore = useUserStore();

	API.init().addBusinessDevice(userStore.currBusinessId, deviceId, token, soundIndex, function(response) {

	});

}

window.printReportResult = function (result) {
	let epsonStore = useEpsonStore();
	epsonStore.printReportResult = result;
}

window.zReportResultIngest = function (result, zRep, serialNumber, baseUrl, xmlFile, txtFile, xmlDataString, txtDataString) {
	let epsonStore = useEpsonStore();

	if(xmlDataString) {
		epsonStore.zReportResultIngest(xmlDataString, result, zRep, serialNumber, baseUrl, xmlFile, txtFile, txtDataString);
	}
	else if (result === "wrong-printer") {
		useNotificationStore().showNotification('z-rep-reinjest-wrong-printer-error', [epsonStore.zreportToReinjest.serial_number]);
		epsonStore.zreportToReinjest = null;
	}
}

window.offlineHook = function (offline) {
	let unchangingStore = useUnchangingStore();
	unchangingStore.offline = offline;
	console.log("Changed online status to: "+offline);
}

window.addEventListener('online', () => window.offlineHook(false));
window.addEventListener('offline', () => window.offlineHook(true));


window.successTapPhoneConnection = function (type) {

	if(type === "tap_on_phone") {
		localStorage.setItem("tapPhoneActive", "1");
	} else if(type === "bluetooth") {
		localStorage.setItem("bluetoothActive", "1");
	} else if(type === "handoff") {
		localStorage.setItem("handoffActive", "1");
	}
	let sunmiStore = useSunmiStore()
	sunmiStore.successTapPhoneConnection = true;

}

window.failedTapPhoneConnection = function () {
	console.log("failedTapPhoneConnection");
	let sunmiStore = useSunmiStore()
	sunmiStore.failedTapPhoneConnection = true;
}

window.failedTapPhonePayment = function (message) {

	let sunmiStore = useSunmiStore()
	sunmiStore.failedTapPhonePayment = message;

}

window.notifyBluetoothUpdateProgress = function (progress) {

	let sunmiStore = useSunmiStore()
	if(progress > 1) {
		sunmiStore.bluetoothUpdateProgress = null;
		window.successTapPhoneConnection("bluetooth");
	} else {
		sunmiStore.bluetoothUpdateProgress = progress*100;
	}

}

// Register shared Cashmatic callbacks
registerCashmaticCallbacks();

//TODO remove
window.toggleDarkMode = function () {
	const userStore = useUserStore();
	localStorage.setItem("darkMode", userStore.darkMode ? "0" : "1");
	userStore.initDarkMode();
}